//TODO: Some of these HARD CODED values need to be moved elsewhere after the DEMO
export const DocumentObjectDefaults = {
  Filing: {
    Book: {},
    Public_Document_Ind: 'N',
    File_External_Ind: 'N',
    File_Drawer: '?',
    File_Folder: '?'
  }
};
